module.exports = __webpack_public_path__ + "static/icons/icon-eyeball-reporter-1a39ca184e52938501945603997db9e5.svg";